module.exports = __webpack_public_path__ + "static/media/sign_flc.f58d89fd.png";